import ko from 'knockout'
import template from './modal-template.tpl.html'

ko.components.register('tt-modal', {
  viewModel: {
    createViewModel: (params: { viewModel: unknown }) => params.viewModel,
  },
  template: template,
})
